import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'QrAppDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean };





const cancel = async () => {
  emit("input", false);
};

return { __sfc: true,props, emit, cancel }
}

})